import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { theme } from '../../themes/theme'
import { FlexColumn, FlexRow, LightBGContainer } from '../styles/Containers'
import SettingCard from './SettingCard'
import Breadcrumbs from './Breadcrumbs'

const BreadcrumbRow = styled(FlexRow)`
  min-height: 37px;
  align-items: center;
`

const CardContainer = styled(LightBGContainer)`
  padding: 20px;

  :hover {
    background: ${theme.colors.primaryExtraLight};
    cursor: pointer;
  }

  :focus-visible {
    outline: 1px solid ${theme.colors.primary};
  }
`

function SectionSettingsList({ sectionLabel, settings = {}, handleSelectSetting = () => {} }) {
  return (
    <FlexColumn width="100%" gap="10px">
      <BreadcrumbRow>
        <Breadcrumbs crumbs={[{ label: sectionLabel }]} />
      </BreadcrumbRow>
      {Object.keys(settings).map(s => {
        return (
          <CardContainer
            key={s}
            role="button"
            tabIndex={0}
            onClick={() => handleSelectSetting(s)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleSelectSetting(s)
              }
            }}>
            <SettingCard {...settings[s]} />
          </CardContainer>
        )
      })}
    </FlexColumn>
  )
}

SectionSettingsList.propTypes = {
  sectionLabel: PropTypes.string.isRequired,
  settings: PropTypes.object,
  handleSelectSetting: PropTypes.func
}

export default SectionSettingsList
